// src/common/translation.js

export const translations = {
  en: {
    greeting: "You've been envious of starbucks gifts so far, haven't you?",
    headlineLine1: 'Now create your own',
    headlineLine2: 'Store gift',
    qrCodeTitleLine1: 'Qr code and mobile',
    qrCodeTitleLine2: 'Page for gifting',
    qrCodeDescriptionLine1: "By signing up, you get your own store's",
    qrCodeDescriptionLine2: 'Qr code and mobile page for gifting!',
    promotionTitleLine1: 'Promote your qr code',
    promotionTitleLine2: 'Anywhere',
    promotionDescriptionLine1:
      'Promote your qr code on offline stores, online websites,',
    promotionDescriptionLine2:
      'Naver cafe, blog, map services, and any social site!',
    scanTitleLine1: 'Anyone can scan the',
    scanTitleLine2: 'Qr code to gift',
    scanDescriptionLine1: 'Customers who love your store can scan the qr code',
    scanDescriptionLine2: 'And gift it to anyone!',
    redeemTitleLine1: "Scan the customer's",
    redeemTitleLine2: 'Gift qr code',
    redeemDescriptionLine1: "Scan the customer's gift qr code to verify",
    redeemDescriptionLine2:
      'And provide the gift upon successful verification!',
    salesTitleLine1: 'Check sales status',
    salesTitleLine2: 'In real-time',
    salesDescriptionLine1: 'You can check the sales status in real-time',
    salesDescriptionLine2:
      'And process refunds for customers who have purchased gifts!',
    paymentTitleLine1: 'Gift sales payment',
    paymentTitleLine2: 'Conditions',
    paymentDescriptionLine1: 'Gift sales payments are subject to escrow',
    paymentDescriptionLine2:
      'And will not be deposited immediately to the store.',
    paymentDescriptionLine3:
      'Payment will be made according to the terms of payment.',
    paymentNoteLine1:
      "The deposit date follows the payment provider's schedule.",
    paymentNoteLine2:
      'It will be automatically deposited if the gift validity period expires.',
    paymentNoteLine3: 'A service fee will be deducted upon deposit.',
    paymentNoteStorePgShort: 'No separate PG contract required for stores.',
    paymentNoteDepositDetail:
      'Deposit date follows Naegift settlement schedule after customer receives product.',
    logoAlt: 'Naegift',
    serviceIntro: 'Service introduction',
    storeSupport: 'Store support',
    logout: 'Logout',
    myPage: 'My page',
    login: 'Store Admin',
    signup: 'Sign up',
    toggleLanguage: '한글',
    termsOfService: 'Terms of service',
    privacyPolicy: 'Privacy policy',
    emailContact: 'contact@authrium.com',
    copyright: 'Copyright by Authrium Co., Ltd. All Rights Reserved.',

    // Added Translations for UserSignUp Page
    home: 'Home',
    signupPage: 'Sign Up',
    agreeToAll: 'Agree to all terms',
    serviceTerms: '[Required] Terms of Service',
    viewAll: 'View All',
    privacyPolicyTitle: '[Required] Privacy Policy',
    nextButton: 'Next',
    modalHeader: 'Modal Header', // Placeholder translation
    modalMainMsg: 'Modal Main Message', // Placeholder translation

    adminInfo: '01. Admin Information',
    enterAdminInfo:
      'Please enter administrator information for using the Naegift service.',
    id: 'ID',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    name: 'Name',
    birthday: 'Date of Birth',
    gender: 'Gender',
    male: 'Male',
    female: 'Female',
    email: 'Email',
    emailAuthCode: 'Email Authentication Code',
    phoneNumber: 'Phone Number',
    phoneNumberHint: 'Landline and mobile numbers are both accepted.',
    phoneAuthCode: 'Phone Authentication Code',
    address: 'Address',
    receiveConsent: 'SMS/Push/Email Consent',
    receiveAgree: 'Agree',
    receiveDisagree: 'Disagree',
    receiveInfo:
      '※ To use the Naegift service, you must agree to receive SMS/Push/Email notifications.',
    duplicateCheck: 'Check Duplicate',
    requestAuthCode: 'Request Auth Code',
    validateAuthCode: 'Validate Auth Code',
    searchAddress: 'Search',
    postalCode: 'Postal Code',
    roadAddress: 'Road Address',
    jibunAddress: 'Jibun Address',
    detailAddress: 'Detail Address',
    referenceItem: 'Reference Item',
    cancel: 'Cancel',
    next: 'Next',
    back: 'Back',

    // Validation messages (modal + inline)
    agreeRequired: 'Please agree to receive notifications.',
    idRule: 'ID must be 5-15 lowercase letters (lowercase required).',
    idRuleHint:
      '5-15 characters, lowercase required. Consecutive digits only (e.g. 1111) are not allowed.',
    idDuplicate: 'This ID is already in use. Please use a different ID.',
    idCheckRequired: 'Please check for duplicate ID.',
    idAvailable: 'This ID is available.',
    idRequired: 'Please enter your ID.',
    idFormatHint: 'Lowercase letters and numbers only.',
    idPlaceholder: '5-15 lowercase letters',
    passwordRule:
      '8-16 characters with 2+ of: letters, numbers, special characters.\n3+ consecutive identical digits/letters are not allowed.',
    passwordFormatHint: 'Letters, numbers, and special characters only.',
    passwordMismatch: 'Passwords do not match (case sensitive).',
    passwordRequired: 'Please enter your password.',
    passwordConfirmRequired: 'Please confirm your password.',
    nameRequired: 'Please enter your name.',
    nameNoNumber: 'Numbers are not allowed in name.',
    birthdayRequired: 'Please enter your date of birth.',
    emailRequired: 'Please enter your email.',
    emailInvalid: 'Invalid email address.',
    emailEmptyHint: 'Please enter your email address.',
    emailSpaceHint: 'Spaces in email will be automatically removed.',
    emailAuthGetRequired: 'Please request email verification code.',
    emailAuthRequired:
      'Please receive and verify the email authentication code.',
    emailAuthError: 'Email verification code does not match. Please try again.',
    emailAuthSuccess: 'Email verification complete.',
    emailAuthCheck: 'Check your email for the verification code.',
    verifyEmail: 'Please verify your email.',
    smsAuthGetRequired: 'Please request SMS verification code.',
    smsAuthRequired: 'Please receive and verify the phone authentication code.',
    smsAuthError: 'SMS verification code does not match. Please try again.',
    smsAuthSuccess: 'Phone verification complete.',
    smsAuthCheck: 'Check your SMS for the verification code.',
    smsRequired: 'Please verify your phone number.',
    verifySMS: 'Please verify your phone number.',
    phoneFormat:
      'Enter phone number as XXX-XXXX-XXXX (e.g. 02-123-4567, 032-517-1642, 010-1234-5678).',
    postalCodeRequired:
      'Please enter postal code. Use Search to find your address.',
    roadAddressRequired:
      'Please enter road address. Use Search to find your address.',
    jibunAddressRequired:
      'Please enter jibun address. Use Search to find your address.',
    detailAddrRequired: 'Please enter your detailed address.',
    apiError: 'API server error. Please try again later.',
    storeDataRequired:
      'Store information not found. Please enter store information in the previous step.',
    storeDataRedirectMsg:
      'Please enter store information first.\nRedirecting to the previous step.',
    storeRegistering: 'Processing registration.....',
    sendingEmail: 'Sending email.....',
    sendingSms: 'Sending SMS.....',
    inputInvalid: 'Invalid',
    digitsOnly: 'Numbers only.',

    // Modal Confirmations
    confirm: 'Confirm',
    cancelText: 'Cancel',
    alertMessage: 'Message',
    passwordPlaceholder:
      'Combination of letters, numbers, and special characters, 8-16 characters long',
    emailPlaceholder: 'EX)naegift@naver.com',

    storeInfo: 'Store Information',
    storeInfoDescription1:
      'Please provide store information for your gift service.',
    storeInfoDescription2:
      'This information will be visible to your customers.',
    storeName: 'Store Name',
    representativeName: 'Representative Name',
    representativeNamePlaceholder: 'Name as shown on business registration',
    storeLogo: 'Store Logo',
    fileDescription:
      '※ You can attach jpg, jpeg, gif, and png files. You can upload one file up to 3MB.',
    bizCertFile: 'Business Registration Certificate',
    bizCertFileDescription:
      '※ You can attach a PDF or image file (jpg, jpeg, png) up to 10MB.',

    sameAsAdmin: 'Same as Admin Phone',
    sameAsAdminAddress: 'Same as Admin Address',

    selectBank: 'Select bank',
    bankAccountNumber: 'Bank account number',
    accountHolder: 'Account holder',
    giftQR: 'Gift QR code',
    downloadQR: 'Download gift QR code',
    printQR: 'Print gift QR code',
    createQR: 'Create gift QR code',
    bankAccountinput: "Please enter only numbers without '-'",

    storeJoinHeading: 'Considering joining the store, still contemplating?',
    storeJoinDescription:
      'Check out the guide for store owners, from entry procedures to operation tips.',
    storeJoinButton: '🏠 View details on how to participate (Naver Cafe) →',

    promotionDescriptionLine3: 'Promote anywhere!',
    paymentNoteRefund:
      'Gift refunds and resales are handled by Naegift Market, not the store.',
    businessRegNo: 'Business Registration No. : 849-85-02924',
    representative: 'Representative : Ko Seungkon',
    companyName: 'Company : Authrium Co., Ltd.',
    phoneLabel: 'Phone : 070-4010-8203',
    addressFull:
      'Address : 229, Seokjeong-ro, Michuhol-gu, Incheon, 811 (Dohwa-dong, Incheon Blockchain Hub Center)',
    customerCenterHours: 'Customer Service: Mon-Fri 09:00 - 18:00',
    lunchBreakNotice:
      '(Closed 12:00-13:00 for lunch / Closed weekends and holidays)',
    copyrightFull: 'Copyright by Authrium Co., Ltd. All Rights Reserved',
    idSearch: 'Find ID',
    pwdSearch: 'Find Password',
    idSearchHint:
      'You can find your ID through the email you entered when signing up.',
    userIdRequired: 'Please enter your user ID.',
    pwdSearchHint:
      'You can find your password through the email you entered when signing up.',
    idSearchSending: 'Searching for ID and sending email.....',
    pwdSearchSending: 'Sending password reset email.....',
    storeAdminNotFound: 'Store admin information not found.',
    requestError: 'An error occurred. Please try again later.',
    idSearchDoneMessage: 'Your ID has been sent to the email address on file.',
    idSearchDoneMessageHighlight: 'Your ID has been sent to the email address',
    pwdSearchDoneMessage:
      'Your temporary password has been sent to the email address on file.',
    pwdSearchDoneMessageHighlight:
      'Your password has been safely reset and sent to the email address',
    pwdChangeReminder: 'Please change your password after logging in.',
    pwdSearchDoneFull:
      'Your temporary password has been sent to the email address on file. Please log in with the temporary password and change your password in your account settings.',
    pwdReset: 'Reset Password',
    agreeTermsRequired: 'Please agree to the terms.',
    signupComplete: 'Signup Complete',
    signupCongrats: 'Congratulations on joining Naegift!',
    signupThanks: 'Thank you for signing up.',
    signupThanksName: '{name}, thank you for signing up to Naegift.',
    signupIdIs: 'Your ID is',
    signupIdEnd: '.',
    signupIdNoticeFull: 'You can use all services freely with this ID.',
    signupServiceNotice: 'Please use our service with care.',
    signupPromise:
      'We will strive to fulfill member satisfaction through various services.',
    market: 'Market',
    toggleLanguageKo: 'EN',
    toggleLanguageEn: '한글',
    passwordChangeTitle: 'Change Password',
    passwordRuleAvailable: 'Available: letters, numbers, special characters',
    passwordRuleUnavailable: 'Not available: consecutive same characters',

    // Store info (storeContent.js)
    bizNum: 'Business number',
    bizType: 'Business type',
    individualBiz: 'Individual business',
    corporateBiz: 'Corporate business',
    bizTypeAutoSet: 'Set automatically after verification',
    ageRestriction: 'Age classification',
    ageRestrictionGeneral: 'All ages',
    ageRestrictionAdult: 'Adult only',
    storeSearch: 'Find store',
    storeSearchHint: 'Enter store name and search. (Crawled stores only)',
    storeSearchPlaceholder: 'Store name',
    search: 'Search',
    searching: 'Searching...',
    close: 'Close',
    noSearchResult: 'No results found.',
    storeSearchEmptyHint: 'Enter store name and search.',
    naverMapLink: 'Naver Map link',
    kakaoMapLink: 'Kakao Map link',
    instagramLink: 'Instagram link',
    accountValidation: 'Account verification',
    accountPlaceholder: 'Will be filled after account verification.',
    storeSelectedFromCrawl: 'Store selected from crawl',
    bizNumVerifyButton: 'Verify business number',
    appDownload: 'App download',
    appDownloadTitle: 'Get the Naegift app',
    appDownloadIconAlt: 'Naegift',
    appDownloadAppleAlt: 'Download on the App Store',
    appDownloadGoogleAlt: 'Get it on Google Play',
  },
  ko: {
    greeting: '그 동안 스타벅스 기프트를 보면서 부러워만 하셨죠?',
    headlineLine1: '이젠 우리 상점만의',
    headlineLine2: '기프트를 만들어 보세요',
    qrCodeTitleLine1: '선물하기 QR코드 및',
    qrCodeTitleLine2: '모바일 페이지 제공',
    qrCodeDescriptionLine1: '회원가입만 하면 우리 상점만의 선물하기',
    qrCodeDescriptionLine2: 'QR코드 및 모바일 페이지가 생깁니다!',
    promotionTitleLine1: '선물하기 QR코드를',
    promotionTitleLine2: '어디에나 홍보하기',
    promotionDescriptionLine1:
      '선물하기 QR코드를 오프라인 매장, 온라인 홈페이지,',
    promotionDescriptionLine2:
      '네이버카페, 블로그, 지도서비스, 각종 소셜 사이트',
    scanTitleLine1: '어느누구나 선물하기',
    scanTitleLine2: 'QR코드 스캔 후 선물하기',
    scanDescriptionLine1: '우리 상점을 아끼는 손님들은 선물하기 QR코드 스캔 후',
    scanDescriptionLine2: '누구에게나 우리 상점의 기프트를 선물할 수 있습니다!',
    redeemTitleLine1: '손님의 기프트',
    redeemTitleLine2: 'QR코드 스캔 후 상품제공',
    redeemDescriptionLine1: '선물받은 손님의 기프트 QR코드를 스캔해서',
    redeemDescriptionLine2: '기프트를 검증하고 검증성공시 상품을 제공하세요!',
    salesTitleLine1: '판매현황 실시간',
    salesTitleLine2: '확인하기',
    salesDescriptionLine1: '기프트 판매현황을 실시간으로 볼 수 있고,',
    salesDescriptionLine2:
      '기프트를 구매한 손님들에게 환불 등을 할 수 있습니다!',
    paymentTitleLine1: '기프트 판매대금',
    paymentTitleLine2: '지급조건',
    paymentDescriptionLine1:
      '기프트 판매 대금은 에스크로가 적용되어 상점으로 즉시',
    paymentDescriptionLine2: '입금되지 않고 손님의 기프트 QR코드 스캔 후에 ',
    paymentDescriptionLine3: '지급 조건에 따라 입금됩니다.',
    paymentNoteLine1: '입금일은 결제사 지급일에 따릅니다.',
    paymentNoteLine2: '기프트 유효기간 경과시에 자동입금됩니다.',
    paymentNoteLine3: '입금시 내기프트 서비스 이용료를 제하고 입금됩니다.',
    paymentNoteStorePgShort:
      '상점에서 PG(결제대행사)와 별도 계약할 필요가 없습니다.',
    paymentNoteDepositDetail:
      '손님이 상품 수령 후 상점 입금일은 내기프트 정산 지급 주기에 따릅니다.',
    logoAlt: '내기프트',
    serviceIntro: '서비스 소개',
    storeSupport: '상점지원',
    logout: '로그아웃',
    myPage: '마이페이지',
    login: '상점 관리자',
    signup: '회원가입',
    toggleLanguage: 'EN',
    termsOfService: '서비스이용약관',
    privacyPolicy: '개인정보취급방침',
    emailContact: 'contact@authrium.com',
    copyright: 'Copyright by Authrium Co., Ltd. All Rights Reserved.',

    // Added Translations for UserSignUp Page
    home: '홈',
    signupPage: '회원가입',
    agreeToAll: '전체 약관에 동의합니다.',
    serviceTerms: '[필수] 서비스이용약관',
    viewAll: '전체보기',
    privacyPolicyTitle: '[필수] 개인정보취급방침',
    nextButton: '다음',
    // Previous translations here...

    // New translations for UserSignUp component
    modalHeader: '모달 헤더', // Placeholder translation
    modalMainMsg: '모달 메인 메시지', // Placeholder translation

    adminInfo: '01.관리자 정보',
    enterAdminInfo: '내기프트 서비스 이용을 위해 관리자 정보를 입력 해 주세요.',
    id: '아이디',
    password: '비밀번호',
    confirmPassword: '비밀번호 확인',
    name: '이름',
    birthday: '생년월일',
    gender: '성별',
    male: '남자',
    female: '여자',
    email: '이메일',
    emailAuthCode: '이메일 인증번호',
    phoneNumber: '전화번호',
    phoneNumberHint: '※ 일반번호/휴대폰 번호 둘 다 입력 가능합니다.',
    phoneAuthCode: '전화번호 인증번호',
    address: '주소',
    receiveConsent: 'SMS/푸시/이메일 수신동의',
    receiveAgree: '수신동의',
    receiveDisagree: '수신거부',
    receiveInfo:
      '※ 내기프트 서비스를 이용하기 위해서는 SMS/푸시/이메일 수신을 동의하셔야 합니다.',
    duplicateCheck: '중복확인',
    requestAuthCode: '인증번호받기',
    validateAuthCode: '인증하기',
    searchAddress: '찾기',
    postalCode: '우편번호',
    roadAddress: '도로명주소',
    jibunAddress: '지번주소',
    detailAddress: '상세주소',
    referenceItem: '참고항목',
    cancel: '취소',
    next: '다음',
    back: '뒤로',

    // Validation messages (modal + inline)
    agreeRequired: '수신동의 해주세요.',
    idRule: '아이디는 영문 소문자 5~15자 이내로 해주세요. (영문 소문자 필수)',
    idRuleHint:
      '영문 소문자 5~15자 (영문 소문자 필수).\n연속된 숫자만(예: 1111)은 사용할 수 없습니다.',
    idDuplicate: '중복된 아이디 입니다. 다른 아이디를 넣어주세요',
    idCheckRequired: '아이디 중복확인 해주세요.',
    idAvailable: '사용할 수 있는 아이디입니다.',
    idRequired: '아이디를 입력해 주세요.',
    idFormatHint: '영문 소문자, 숫자만 입력하세요.',
    idPlaceholder: '영문 소문자 5~15자',
    passwordRule:
      '영문, 숫자, 특수문자 중 2가지 이상 조합 8~16자.\n3자 이상 동일한 숫자/문자는 사용이 불가합니다.',
    passwordFormatHint: '영문/숫자/특수문자만 입력 가능합니다.',
    passwordMismatch: '비밀번호가 일치하지 않습니다(대소문자 구분).',
    passwordRequired: '비밀번호를 입력해 주세요.',
    passwordConfirmRequired: '비밀번호 확인 해주세요.',
    nameRequired: '이름을 입력해 주세요.',
    nameNoNumber: '이름에는 숫자를 입력할 수 없습니다.',
    birthdayRequired: '생년월일을 입력해 주세요.',
    emailRequired: '이메일을 입력해 주세요.',
    emailInvalid: '이메일 주소가 유효하지 않습니다.',
    emailEmptyHint: '이메일 주소를 입력하세요.',
    emailSpaceHint: '이메일의 공백은 자동으로 제거됩니다.',
    emailAuthGetRequired: '이메일 인증번호받기를 해주세요.',
    emailAuthRequired: '이메일 인증번호를 받고 인증하기를 하세요.',
    emailAuthError: '이메일 인증번호가 다릅니다. 다시 해주세요',
    emailAuthSuccess: '이메일 인증번호가 확인 되었습니다.',
    emailAuthCheck: '인증번호를 메일에서 확인하고 넣어주세요!',
    verifyEmail: '이메일 인증 해주세요.',
    smsAuthGetRequired: '전화번호 인증번호받기를 해주세요.',
    smsAuthRequired: '전화번호 인증번호를 받고 인증하기를 하세요.',
    smsAuthError: '전화번호 인증번호가 다릅니다. 다시 해주세요',
    smsAuthSuccess: '전화번호 인증번호가 확인 되었습니다.',
    smsAuthCheck: '인증번호를 SMS로 확인하고 넣어주세요.',
    smsRequired: '전화번호 인증번호를 받고 인증하기를 하세요.',
    verifySMS: '전화번호 인증 해주세요.',
    phoneFormat:
      '전화번호를 올바른 형식으로 입력해 주세요.\n(예: 02-123-4567, 032-517-1642, 010-1234-5678)',
    postalCodeRequired:
      '우편번호를 입력해 주세요. 주소 찾기 버튼을 눌러 주소를 검색해 주세요.',
    roadAddressRequired:
      '도로명주소를 입력해 주세요. 주소 찾기 버튼을 눌러 주소를 검색해 주세요.',
    jibunAddressRequired:
      '지번주소를 입력해 주세요. 주소 찾기 버튼을 눌러 주소를 검색해 주세요.',
    detailAddrRequired: '상세주소를 입력해 주세요.',
    apiError: 'API 서버에러입니다. 잠시 후 다시 시도해주세요.',
    storeDataRequired:
      '상점 정보가 없습니다. 이전 단계에서 상점 정보를 입력해 주세요.',
    storeDataRedirectMsg:
      '상점 정보를 먼저 입력해 주세요.\n이전 단계(상점 정보)로 이동합니다.',
    storeRegistering: '회원가입 처리 중입니다.....',
    sendingEmail: '메일을 보내는 중입니다.....',
    sendingSms: 'SMS를 보내는 중입니다.....',
    inputInvalid: '사용 불가',
    digitsOnly: '숫자만 입력할 수 있습니다.',

    // Modal Confirmations
    confirm: '확인',
    cancelText: '취소',
    alertMessage: '메시지',
    passwordPlaceholder:
      '영문, 숫자, 특수문자 중 2가지 이상 조합 8~16자.\n3자 이상 동일한 숫자/문자는 사용이 불가합니다.',
    emailPlaceholder: '예)naegift@naver.com',

    storeInfo: '상점 정보',
    storeInfoDescription1: '기프트 서비스를 위한 상점 정보를 입력해주세요.',
    storeInfoDescription2: '이 정보는 고객에게 표시됩니다.',
    storeName: '상점명',
    representativeName: '대표자명',
    representativeNamePlaceholder: '사업자등록증상 대표자명',
    storeLogo: '상점 로고',
    fileDescription:
      '※ jpg,jpeg,gif,png 파일 첨부 가능, 1개 파일을 3MByte까지 업로드 할 수 있습니다.',
    bizCertFile: '사업자등록증',
    bizCertFileDescription:
      '※ PDF 또는 이미지(jpg,jpeg,png) 파일 첨부 가능, 10MByte까지 업로드 할 수 있습니다.',

    sameAsAdmin: '관리자 전화번호와 동일',
    sameAsAdminAddress: '관리자 주소와 동일',

    selectBank: '입금받을 은행',
    bankAccountNumber: '입금받을 계좌번호',
    accountHolder: '예금주',
    giftQR: '선물하기 QR 코드',
    downloadQR: '선물하기 QR코드 저장하기',
    printQR: '선물하기 QR코드 프린트하기',
    createQR: '선물하기 QR코드 생성하기',
    bankAccountinput: "'-' 없이 숫자만 넣으세요",

    storeJoinHeading: '가게 참여, 아직 고민 중이신가요?',
    storeJoinDescription:
      '입점 절차부터 운영 팁까지, 사장님들을 위한 가이드를 확인해 보세요.',
    storeJoinButton: '🏠 상점 참여 방법 자세히 보기 (네이버 카페) →',

    promotionDescriptionLine3: '어디든 올리고 홍보하세요!',
    paymentNoteRefund:
      '손님의 내기프트 환불, 재판매 등은 상점이 아닌 내기프트 마켓에서 처리됩니다.',
    businessRegNo: '사업자등록번호 : 849-85-02924',
    representative: '대표자 : 고승곤',
    companyName: '상호 : (주)오스리움',
    phoneLabel: '전화번호 : 070-4010-8203',
    addressFull:
      '주소 : 인천 미추홀구 석정로 229, 811호 (도화동,인천블록체인허브센터)',
    customerCenterHours: '고객센터 운영시간: 평일 09:00 - 18:00',
    lunchBreakNotice: '(점심시간 12:00~13:00 미운영 / 주말 및 공휴일 휴무)',
    copyrightFull: 'Copyright by. (주)오스리움. All Rights Reserved',
    idSearch: '아이디 찾기',
    pwdSearch: '비밀번호 찾기',
    idSearchHint: '아이디는 가입 시 입력하신 이메일을 통해 찾을 수 있습니다.',
    userIdRequired: '사용자 아이디를 입력하세요.',
    pwdSearchHint:
      '비밀번호는 가입 시 입력하신 이메일을 통해 찾을 수 있습니다.',
    idSearchSending: '아이디를 찾아 메일을 발송중입니다.....',
    pwdSearchSending: '비밀번호를 재발급하여 메일을 발송중입니다.....',
    storeAdminNotFound: '상점 관리자 정보가 없습니다.',
    requestError:
      '요청 처리 중 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.',
    idSearchDoneMessage:
      '회원정보상의 이메일주소로 회원님의 아이디를 발송하였습니다.',
    idSearchDoneMessageHighlight: '이메일주소로 회원님의 아이디를 발송',
    pwdSearchDoneMessage:
      '회원정보상의 이메일주소로 임시 비밀번호를 발송하였습니다.',
    pwdSearchDoneMessageHighlight:
      '이메일주소로 회원님의 비밀번호를 안전하게 재발급',
    pwdChangeReminder: '로그인 후 비밀번호를 변경해 주세요.',
    pwdSearchDoneFull:
      '회원정보상의 이메일주소로 회원님의 비밀번호를 안전하게 재발급하여 드립니다. 임시비밀번호로 로그인 하신 후, 회원정보에서 비밀번호를 변경해주세요.',
    pwdReset: '비밀번호 재발급 받기',
    agreeTermsRequired: '약관 동의를 해주세요.',
    signupComplete: '회원가입 완료',
    signupCongrats: '내기프트 가입을 축하드립니다!',
    signupThanks: '내기프트에 가입해주셔서 감사합니다.',
    signupThanksName: '{name}님, 내기프트에 가입해주셔서 감사합니다.',
    signupIdIs: '님의 아이디는',
    signupIdEnd: ' 입니다.',
    signupIdNoticeFull:
      '본 아이디로 모든 서비스를 자유롭게 이용하실 수 있습니다.',
    signupServiceNotice: '내기프트 서비스를 편리하게 이용해 주세요.',
    signupPromise:
      '더욱 다양한 서비스를 통해 회원만족을 실현하는 내기프트가 되겠습니다.',
    market: '마켓',
    toggleLanguageKo: 'EN',
    toggleLanguageEn: '한글',
    passwordChangeTitle: '비밀번호 변경하기',
    passwordRuleAvailable: '※ 사용 가능 : 영문, 숫자, 특수문자',
    passwordRuleUnavailable: '※ 사용 불가 : 3자 이상 동일한 숫자/문자 연속',

    // Store info (storeContent.js)
    bizNum: '사업자번호',
    bizType: '사업자 유형',
    individualBiz: '개인사업자',
    corporateBiz: '법인사업자',
    bizTypeAutoSet: '사업자번호 조회 후 자동 설정됨',
    ageRestriction: '업종 연령 분류',
    ageRestrictionGeneral: '전체 이용가',
    ageRestrictionAdult: '성인 이용가',
    storeSearch: '상점 찾기',
    storeSearchHint:
      '상점명을 입력 후 검색해 주세요. (크롤링된 임시 상점만 표시)',
    storeSearchPlaceholder: '상점명 입력',
    search: '검색',
    searching: '검색 중...',
    close: '닫기',
    noSearchResult: '검색 결과가 없습니다.',
    storeSearchEmptyHint: '상점명을 입력 후 검색해 주세요.',
    naverMapLink: '네이버 지도 링크',
    kakaoMapLink: '카카오맵 링크',
    instagramLink: '인스타그램 링크',
    accountValidation: '계좌 실명 조회',
    accountPlaceholder: '계좌 실명 조회 후 자동 입력됩니다.',
    storeSelectedFromCrawl: '크롤링 상점 선택됨',
    bizNumVerifyButton: '사업자등록번호 조회',
    appDownload: '앱 다운로드',
    appDownloadTitle: '내기프트 앱 설치',
    appDownloadIconAlt: '내기프트',
    appDownloadAppleAlt: 'App Store에서 다운로드',
    appDownloadGoogleAlt: 'Google Play에서 다운로드',
  },
};
